import styled from 'styled-components';

export {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FooterActions,
  ModalCancelButton,
} from '../../../AdminPages/Clients/modals/CreateAndUpdateClientModal.styles';

export const InviteCodeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  padding: ${({ theme }) => theme.landingSpacing.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  background: ${({ theme }) => theme.landing.iconBg};
`;

export const InviteCodeText = styled.span`
  font-family: 'SFMono-Regular', ui-monospace, Menlo, Consolas, monospace;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.landing.text};
`;

export const CopyIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.lg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;

  svg {
    width: 13px;
    height: 13px;
  }

  &:hover {
    background: ${({ theme }) => theme.landing.background};
    border-color: ${({ theme }) => theme.landing.textMuted};
  }
`;

export const InviteMessagePreview = styled.div`
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  overflow: hidden;
  background: #ffffff; /* email preview always renders on a white "paper" like a real client */
`;

export const InviteMessageLoading = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  padding: ${({ theme }) => theme.landingSpacing.lg};
  color: ${({ theme }) => theme.landing.textSecondary};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};

  svg {
    width: 16px;
    height: 16px;
    animation: spin 1s linear infinite;
  }
`;

export const InviteMessageError = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  align-items: flex-start;
  padding: ${({ theme }) => theme.landingSpacing.lg};
  color: ${({ theme }) => theme.landing.errorColor};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
`;
